import {Button, H3} from '@hm/fundamental'
import React from 'react'
import {Controller, useFormContext} from 'react-hook-form'

import {useTranslation} from '../../../hooks/useTranslation'
import {
  CHANGE_ROLE_TYPE,
  GroupedRoleReducerAction
} from '../../../modules/GroupedRoleAssignmentReducer'
import {GroupedRoleAssignment, RoleType} from '../../../modules/ManageUsers.selectors'

import {SelectGrouped, SelectGroupedOption} from './SelectGrouped'

type RoleEditorProps = {
  groupedRoleAssignment: GroupedRoleAssignment
  dispatchRoleStateUpdate: React.Dispatch<GroupedRoleReducerAction>
  roleOptions: SelectGroupedOption[]
  onCancel: () => void
  onSave: () => void
}

export const RoleEditor = ({
  roleOptions,
  onCancel,
  onSave,
  dispatchRoleStateUpdate
}: RoleEditorProps) => {
  const {control, formState} = useFormContext<GroupedRoleAssignment>()

  const {t} = useTranslation()

  return (
    <div className="flex flex-col items-start w-full">
      <div className="flex justify-between items-start w-full mb-3">
        <H3>{t('roleAssignment.editRole')}</H3>
        <div className="flex gap-2 items-center">
          <Button variant="secondary" onClick={onCancel}>
              {t('roleAssignment.cancel')}
          </Button>
          <Button
            data-test-id="button-role-save"
            type="submit"
            disabled={formState.isSubmitting}
            onClick={onSave}
          >
              {t('roleAssignment.saveRole')}
          </Button>
        </div>
      </div>
      <Controller
        name="roleType"
        control={control}
        rules={{
          required: t('roleAssignment.roleRequired')
        }}
        render={({field}) => (
          <SelectGrouped
            {...field}
            data-test-id="select-role-type"
            inputLabel={t('roleAssignment.roleType')}
            searchPlaceholder={t('roleAssignment.searchRoles')}
            emptyLabel={t('roleAssignment.defaultSelect')}
            showSearch={true}
            value={field.value}
            onChange={(value) => {
              field.onChange(value)
              dispatchRoleStateUpdate({
                type: CHANGE_ROLE_TYPE,
                payload: value as RoleType
              })
            }}
            options={roleOptions}
          />
        )}
      />
    </div>
  )
}
